import React from 'react';
import { Link } from 'react-router-dom';
import { SITE, NAV, LOCATIONS, SOCIALS, IZI } from '../data/site';
import { ArrowRight, SOCIAL_ICONS } from './Icons';
import Reveal from './Reveal';
import logoCream from '../assets/logo-cream.png';
import './Footer.css';

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="footer section--dark grain">
      <div className="page">
        <Reveal className="footer__top">
          <div className="footer__brand">
            <img src={logoCream} alt="The Local" width="180" height="134" />
            <p className="footer__strap display d4 italic">{SITE.tagline}</p>
          </div>

          <div className="footer__cols">
            <div className="footer__col">
              <p className="eyebrow is-plain">Explore</p>
              <ul className="footer__list">
                {NAV.map((item) => (
                  <li key={item.to}>
                    <Link to={item.to}>{item.label}</Link>
                  </li>
                ))}
              </ul>
            </div>

            {LOCATIONS.map((loc) => (
              <div className="footer__col" key={loc.id}>
                <p className="eyebrow is-plain">{loc.name}</p>
                <ul className="footer__list">
                  <li>
                    <a href={`tel:${loc.phoneIntl}`} className="tabular">
                      {loc.phone}
                    </a>
                  </li>
                  <li>
                    <Link to={`/locations/${loc.id}`}>About this branch</Link>
                  </li>
                  <li>
                    <a href={loc.mapUrl} target="_blank" rel="noopener noreferrer">
                      Get directions
                    </a>
                  </li>
                  {loc.hours.map((h) => (
                    <li key={h.days} className="footer__hours">
                      <span>{h.days}</span>
                      <span className="tabular">{h.time}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}

            <div className="footer__col">
              <p className="eyebrow is-plain">Order &amp; follow</p>
              <ul className="footer__list">
                <li>
                  <a href={IZI.web} target="_blank" rel="noopener noreferrer">
                    Order on {IZI.brand}
                  </a>
                </li>
                {IZI.android ? (
                  <li>
                    <a href={IZI.android} target="_blank" rel="noopener noreferrer">
                      Android app
                    </a>
                  </li>
                ) : null}
                {IZI.ios ? (
                  <li>
                    <a href={IZI.ios} target="_blank" rel="noopener noreferrer">
                      iOS app
                    </a>
                  </li>
                ) : null}
              </ul>
              <div className="footer__socials">
                {SOCIALS.map((s) => {
                  const Icon = SOCIAL_ICONS[s.id];
                  return (
                    <a key={s.id} href={s.url} target="_blank" rel="noopener noreferrer" aria-label={`${s.label} — ${s.handle}`}>
                      <Icon size={17} />
                    </a>
                  );
                })}
              </div>
            </div>
          </div>
        </Reveal>

        <div className="footer__cta">
          <p className="display d3">Come and sit with us.</p>
          <Link to="/bookings" className="btn btn--gold">
            <span>Book a table</span>
            <ArrowRight />
          </Link>
        </div>

        <div className="footer__base">
          <p>© {year} {SITE.legalName}</p>
          <p className="footer__meta">
            {SITE.city}, {SITE.country} · Est. {SITE.established}
          </p>
          <p className="footer__meta">
            Ordering powered by{' '}
            <a href={IZI.web} target="_blank" rel="noopener noreferrer">
              {IZI.brand}
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
